// extracted by mini-css-extract-plugin
export default {"formPopUpContainer":"formPopUp_formPopUpContainer__PMV8i","closeIcon":"formPopUp_closeIcon__vg6Pd"};